import React from 'react'
import category from '../../assets/images/Container.png'
import test1 from '../../assets/images/test1.png'
import test2 from '../../assets/images/test2.png'
import test3 from '../../assets/images/test3.png'
import test4 from '../../assets/images/test4.png'
import test5 from '../../assets/images/test5.png'
import test6 from '../../assets/images/test6.png'
import InitialSWOTHook from '../initialSWOT/initialSWOTHook'
import MaterialHook from '../Material/MaterialHook'
import CalendarHook from '../Calender/CalendarHook'
import RecordingHook from '../Recording/RecordingHook'
import BackupHook from '../backup/BackupHook'

const Categories = () => {
  const { handleInitialSwot } = InitialSWOTHook()
  const { handleMaterial } = MaterialHook()
  const { handleCalendar } = CalendarHook();
  const { handleRecording } = RecordingHook();
  const { handleBackup } = BackupHook();
  return (
    <div>
      <div>
        <h2 className='category'>Categories</h2>
        {/* <p className='text-center'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy</p> */}
      </div>
      <div className='desktop-view'
      //   style={{marginTop:"120px"}}
      >
        <div className='d-flex justify-content-around'>
          <div className='fourth'>
            <div className='text-center' onClick={handleCalendar}>
              <img src={test4} className='catIMg' />
              <p className='fw-bolder'>Calendar/Schedule</p>
            </div>
          </div>
          <div className='fifth'>
            <div className='text-center'>
              <img src={test5} className='catIMg' onClick={handleBackup} />
              <p className='fw-bolder'>Backup Class(es)</p>
            </div>
          </div>
          <div className='sixth'>
            <div className='text-center' onClick={handleRecording}>
              <img src={test6} className='catIMg' />
              <p className='fw-bolder'>Class Recordings</p>
            </div>
          </div>
        </div>
        <div className='my-4 py-4'>
          <div className='d-flex justify-content-around'>

            <div className='second'>
              <div className='text-center' onClick={handleMaterial}>
                <img src={test2} className='catIMg' />
                <p className='fw-bolder'>Practice Material</p>
              </div>
            </div>
            <div className='third'>
              <div className='text-center' onClick={handleInitialSwot}>
                <img src={test3} className='catIMg' />
                <p className='fw-bolder'>Initial Swot</p>
              </div>
            </div>
            <div className='first' onClick={() => window.location.href = 'https://test.mbaguru.in/'}>
              <div className='text-center' >
                <img src={test1} className='catIMg' />
                <p className='fw-bolder'>AIRCATs & Mock Tests</p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className=" cat container mt-5 mobile-view">
        <div className="catDiv row gy-4 gx-3">
          <div className="col-12 col-sm-6 col-md-4">
            <div className='fourth'>
              <div className='text-center' onClick={handleCalendar}>
                <img src={test4} className='catIMg' />
                <p className='fw-bolder'>Calendar/Schedule</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className='fifth'>
              <div className='text-center'>
                <img src={test5} className='catIMg' onClick={handleBackup} />
                <p className='fw-bolder'>Backup Class(es)</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className='sixth'>
              <div className='text-center' onClick={handleRecording}>
                <img src={test6} className='catIMg' />
                <p className='fw-bolder'>Class Recordings</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className='second'>
              <div className='text-center' onClick={handleMaterial}>
                <img src={test2} className='catIMg' />
                <p className='fw-bolder'>Practice Material</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className='third'>
              <div className='text-center' onClick={handleInitialSwot}>
                <img src={test3} className='catIMg' />
                <p className='fw-bolder'>Initial Swot</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className='first' onClick={() => window.location.href = 'https://test.mbaguru.in/'}>
              <div className='text-center' >
                <img src={test1} className='catIMg' />
                <p className='fw-bolder'>AIRCATs & Mock Tests</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Categories
